import { render, staticRenderFns } from "./pandaCoinManage.vue?vue&type=template&id=1e605d49&scoped=true"
import script from "./pandaCoinManage.vue?vue&type=script&lang=ts"
export * from "./pandaCoinManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e605d49",
  null
  
)

export default component.exports